import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=e50af6f2&scoped=true"
import script from "./customers.vue?vue&type=script&lang=js"
export * from "./customers.vue?vue&type=script&lang=js"
import style0 from "./customers.vue?vue&type=style&index=0&id=e50af6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50af6f2",
  null
  
)

export default component.exports